let baseURL: string;

// Include using any externally defined baseURL value as a fallback,
// mostly for unit testing. Please avoid using this unless necessary
// (usually it's not as the browser will use the page's base element).
export function getBaseExclaimUrl(): string {
    const baseEls = typeof document !== 'undefined' && document.getElementsByTagName("base");
    return (baseEls.length ? baseEls[0].getAttribute("href") : undefined) || baseURL;
}

// Legacy, please avoid using as it's not necessary (only declare if something
// hasn't already declared it)
if (typeof baseURL === "undefined") {
    baseURL = getBaseExclaimUrl();
}

// This is used in the unit tests
export function setBaseUrlForUnitTesting(url: string): void {
    baseURL = url;
}
